export const Endpoint = () => `/api/v3/celery/removetask`;
export const Csrf = () => `/api/v3/celery/token/`;
export declare const QueryKey: never;
export type Payload = {
    name: string;
};
export type Response = void;
